import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import entitlementsReducer from './reducers/entitlements';
import reassignUsersReducer from './reducers/reassign_users';
import localizeReducer from './reducers/localize';
import userReducer from './reducers/users';
import { watchEntitlements, watchReassignUsers, watchUsers } from './sagas';

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleWare = createSagaMiddleware();

const reassignPersistConfig = {
  key: 'reassignUsers',
  storage,
  whitelist: ['persistedJobStatuses']
};

const rootReducer = combineReducers({
  entitlements: entitlementsReducer,
  reassignUsers: persistReducer(reassignPersistConfig, reassignUsersReducer),
  localize: localizeReducer,
  user: userReducer
});

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(sagaMiddleWare)));

sagaMiddleWare.run(watchEntitlements);
sagaMiddleWare.run(watchReassignUsers);
sagaMiddleWare.run(watchUsers);

export const persistor = persistStore(store);
export default store;



// WEBPACK FOOTER //
// ./app/javascript/app/store/storeConfig.js